var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCancellationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 73.62 79.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    className: "color000 svgShape color011a91",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "coloradb5b5 svgShape color2c1ab3 color000",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.06 66.9H7.43V29.73h52V48c.37 0 .75-.06 1.13-.06a18.55 18.55 0 016.3 1.12V14.87a7.46 7.46 0 00-7.43-7.44h-3.68V0h-7.43v7.43H18.58V0h-7.43v7.43H7.43A7.46 7.46 0 000 14.87v52a7.45 7.45 0 007.43 7.43h36.35a18.45 18.45 0 01-1.72-7.4zm-34.63-52h52v7.4h-52z",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 51.78a14 14 0 1014 14 14 14 0 00-14-14zM65.68 70l-1.84 1.84-4.24-4.2-4.24 4.24L53.52 70l4.24-4.24-4.24-4.24 1.84-1.84L59.6 64l4.24-4.24 1.84 1.84-4.24 4.2z",
    className: "color000 svgShape color011a91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.56,
    d: "M18.91 39.43L49.61 39.43",
    className: "colorStrokeadb5b5 svgStroke colorStroke011a91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.56,
    d: "M18.91 49.45L37.98 49.45",
    className: "colorStrokeadb5b5 svgStroke colorStroke011a91"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCancellationWhite);
export default __webpack_public_path__ + "static/media/eventCancellationWhite.5f223a80d6403557437391d577ab950e.svg";
export { ForwardRef as ReactComponent };